import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
const _excluded = ["rasterData"];
import RasterLayer from "../../raster";
import Tile from "./Tile";
export default class RasterTile extends Tile {
  initTileLayer() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const attributes = _this.parent.getLayerAttributeConfig();
      const layerOptions = _this.getLayerOptions();
      const sourceOptions = _this.getSourceOption();
      const layer = new RasterLayer(_objectSpread({}, layerOptions)).source(sourceOptions.data, sourceOptions.options);

      // 初始化数据映射
      // tslint:disable-next-line: no-unused-expression
      attributes && Object.keys(attributes).forEach(type => {
        var _attributes$attr, _attributes$attr2;
        const attr = type;
        // @ts-ignore
        layer[attr]((_attributes$attr = attributes[attr]) === null || _attributes$attr === void 0 ? void 0 : _attributes$attr.field, (_attributes$attr2 = attributes[attr]) === null || _attributes$attr2 === void 0 ? void 0 : _attributes$attr2.values);
      });
      yield _this.addLayer(layer);
      _this.isLoaded = true;
    })();
  }
  getSourceOption() {
    const rawSource = this.parent.getSource();
    const _this$sourceTile$data = this.sourceTile.data.data,
      {
        rasterData
      } = _this$sourceTile$data,
      res = _objectWithoutProperties(_this$sourceTile$data, _excluded);
    return {
      data: rasterData,
      // 栅格数
      options: {
        parser: _objectSpread({
          type: 'rasterRgb',
          extent: this.sourceTile.bounds
        }, res),
        transforms: rawSource.transforms
      }
    };
  }
}